import { all, call } from 'redux-saga/effects'

import { authSagas } from './auth/auth-sagas'
import companiesSagas from './companies/companies-sagas'
import adminCompaniesSagas from './admin/admin-companies-sagas'
import noticesSagas from './notices/notices-saga'
import settingsSagas from './settings/settings-sagas'
import reportsSagas from './reports/reports-sagas'
import meterSagas from './meters/meter-saga'

// Note: disabling requiring explicit return types for saga generators
// (as the type is pretty complex and produces little value as explicit)
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function * rootSaga() {
  yield all([
    call(adminCompaniesSagas),
    call(authSagas),
    call(companiesSagas),
    call(meterSagas),
    call(noticesSagas),
    call(reportsSagas),
    call(settingsSagas)
  ])
}
